// Karşı tarafı okuyabilen anahtarlar değişti mi (9.34 · D-634).
//
// KUSUR. Bugüne kadar yeni bir kimlik anahtarı SESSİZCE kabul ediliyordu.
// D-619'da yazdığımız gibi, "yeni kimliği kabul et" kararının tek dayanağı
// zarfın gerçekten çözülmesiydi — ve bu, araya giren birine karşı hiçbir şey
// söylemez: sunucu dizine kendi anahtarını koyarsa zarf da pekâlâ çözülür,
// çünkü onu o yazmıştır. Şifrelemenin bütün varsayımı sunucuya güvenmemek;
// ama anahtarı dağıtan sunucu. Boşluk tam burada.
//
// BİRİM CİHAZ DEĞİL KİŞİ. İlk yazdığım biçim anahtarı cihaz başına izliyordu ve
// en sık gerçekleşen durumu kaçırıyordu: karşı taraf uygulamayı silip kurunca
// sunucu ona YENİ BİR CİHAZ NUMARASI veriyor (numaralar tekrar kullanılmıyor),
// yani "aynı cihazın anahtarı değişti" pratikte hiç olmuyordu. Saldırganın en
// kolay hamlesi de aynı kapıdan geçiyor: kurbanın hesabına fazladan bir cihaz
// eklemek. Sorulması gereken soru "bu cihazın anahtarı değişti mi" değil,
// ŞU: bu kişinin mesajlarımı okuyabilen anahtarları arasına daha önce
// görmediğim biri mi girdi.
//
// EKLENME ÖNEMLİ, ÇIKMA DEĞİL. Bir cihazın dizinden düşmesi kimseye okuma
// yetkisi vermez; o yüzden yalnız yeni anahtarlar olaydır.
//
// ENGELLEMİYOR, SÖYLÜYOR. Meşru sebebi çoğu zaman sıradandır: yeni telefon,
// yeniden kurulan uygulama, ikinci cihaz. Mesajı durdurmak insanların büyük
// çoğunluğunu gerçek bir tehlike olmadan engellerdi. Doğru karşılık, olanı
// sohbette söylemek ve kararı kişiye bırakmaktır. WhatsApp da yeniden
// kurulumda tam olarak bu satırı gösterir.
//
// KAYIT CİHAZA AİT, sunucuya değil. "Bu cihaz daha önce ne gördü" sorusunu
// yalnız cihazın kendisi yanıtlayabilir; sunucuya sormak, denetlenen tarafa
// kendi sicilini sordurmak olurdu.
import { getSecret, setSecret } from './secureStorage';
import { peerIdentities as peerIdentitiesKey, identityLog as identityLogKey } from './storageKeys';

export type IdentityChange = {
  /** Değişikliğin görüldüğü an (ISO). Sohbette zamanına göre yerleşiyor. */
  at: string;
  /** Yeni görülen anahtarlar. Güvenlik numarası ekranı bunları karşılaştıracak. */
  identityKeys: string[];
};

export type IdentitySeen = 'ilk' | 'ayni' | 'degisti';

// Sohbet başına tutulan en fazla kayıt. Sınırsız bırakmak, bir hata durumunda
// deponun sessizce şişmesi demekti; en yenisi en çok işe yarayan olduğu için
// baştan kırpılıyor.
export const MAX_IDENTITY_CHANGES = 20;

async function listeOku<T>(anahtar: string): Promise<T[]> {
  const raw = await getSecret(anahtar);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    // Bozuk kayıt sohbeti engellememeli; en kötü ihtimalle uyarı görünmez.
    return [];
  }
}

/**
 * Bu kişi için görülen kimlik anahtarlarını kaydet ve öncekilerle karşılaştır.
 *
 * İLK görüş bir olay DEĞİL: karşılaştıracak bir şey yokken uyarı vermek her yeni
 * sohbeti şüpheli göstermek olurdu — ve uyarı her yerde görününce hiçbir yerde
 * okunmaz. Bu yüzden ilk temasta kişinin BÜTÜN cihazları birden kaydediliyor;
 * tek tek kaydetseydik, baştan iki telefonu olan biri ikinci cihazı yüzünden
 * hemen uyarı doğururdu.
 */
export async function identitiesSeen(
  peerId: number,
  identityKeys: string[],
): Promise<IdentitySeen> {
  const gecerli = identityKeys.filter((k) => typeof k === 'string' && k.length > 0);
  if (gecerli.length === 0) return 'ayni';

  const anahtar = peerIdentitiesKey(peerId);
  const bilinen = await listeOku<string>(anahtar);
  const yeni = gecerli.filter((k) => !bilinen.includes(k));
  if (yeni.length === 0) return 'ayni';

  // Tekrarları düşür: aynı anahtar iki cihazda görünürse listeyi şişirmesin.
  await setSecret(anahtar, JSON.stringify([...new Set([...bilinen, ...yeni])]));
  if (bilinen.length === 0) return 'ilk';

  const kayit: IdentityChange = { at: new Date().toISOString(), identityKeys: yeni };
  const log = [...(await identityChanges(peerId)), kayit].slice(-MAX_IDENTITY_CHANGES);
  await setSecret(identityLogKey(peerId), JSON.stringify(log));
  return 'degisti';
}

/** Bir sohbette bugüne kadar görülen kimlik değişiklikleri, eskiden yeniye. */
export function identityChanges(peerId: number): Promise<IdentityChange[]> {
  return listeOku<IdentityChange>(identityLogKey(peerId));
}
